{
  "cycle.entite.documents_publications": "Publications des versions de documents",
  "cycle.entite.documents_signatures": "Signatures des versions de documents",
  "cycle.entite.preuves_documents": "Preuves rattachées aux documents",
  "journalAudit.action.approval.decided": "Décision rendue sur un document",
  "journalAudit.action.approval.signed": "Signature d’un document enregistrée",
  "journalAudit.action.document.evidence_attached": "Preuve rattachée à un document",
  "journalAudit.action.document.evidence_reevaluated": "Preuves d’un document réévaluées",
  "journalAudit.action.document.published": "Version de document publiée",
  "journalAudit.action.document.version_abandoned": "Version de document abandonnée",
  "journalAudit.action.process.gate_refused": "Porte de phase refusée",
  "journalAudit.action.taxonomy.renamed": "Étiquette ou rubrique renommée",
  "journalAudit.action.waiver.withdrawn": "Sollicitation de dérogation retirée"
}
